<template>
  <a href="javascript:void(0)" @click.prevent="handleAuthorize">
    <span v-if="!service.is_active && !service.is_deactivated">
      {{ $t("ELIXIO_CONNECT.LOGIN_TO") }} {{ service.name }}</span
    >
    <span v-else> {{ $t("ELIXIO_CONNECT.RE_LOGIN_TO") }} {{ service.name }} </span>
  </a>
</template>

<script>
import { cloneDeep } from "lodash";
import swal from "sweetalert2";
export default {
  name: "ModuleOAuth2Connect",

  components: {},

  props: ["service", "organization"],

  data() {
    const serviceData = cloneDeep(this.service);
    return {
      loading: false,
      serviceData,
    };
  },

  computed: {},

  created() {},

  methods: {
    async subscribe() {
      this.loading = true;
      let success = false;
      const service = this.service;

      try {
        const formData = {
          organizationId: this.organization.id,
          payload: {
            service_name: service.name,
            service_type: service.slug,
          },
        };

        console.clear();

        const response = await this.$store.dispatch(
          "elixioConnectModule/subscribe",
          formData
        );

        if (response.status !== 200) {
          return;
        }

        if ("auth_data" in response.data) {
          const { data } = response;

          this.$notify({
            type: "success",
            message: this.$t("ELIXIO_CONNECT.LOGIN_TO_YOUR_ACCOUNT"),
          });

          const auth_url = data.auth_data.auth_url ?? null;
          const serviceId = data.service_data.elixio_service_id ?? null;
          this.serviceData.id = serviceId;

          success = true;

          if (auth_url) {
            swal.close();

            const popup = window.open(
              auth_url,
              "_blank",
              "width=600,height=600"
            );

            if (popup) {
              const timer = setInterval(() => {
                if (popup.closed) {
                  clearInterval(timer);

                  console.log("serviceData => ", this.serviceData);
                  // La fenêtre est fermée, on déclenche le refresh
                  this.$emit("onSubscribed", {
                    success: true,
                    service: this.serviceData,
                  });

                  this.$notify({
                    type: "success",
                    message:
                      "Authentification terminée. Rafraîchissement en cours...",
                  });
                }
              }, 1000); // check toutes les secondes
            }
          } else {
            this.$notify({
              type: "warning",
              message: this.$t("ELIXIO_CONNECT.NOT_CONFIGURED_YET"),
            });
          }
        }
      } catch (error) {
        console.error("Subscribe => ", error);

        swal.showValidationMessage(`Erreur: ${error}`); // Gère les erreurs

        this.$notify({
          type: "danger",
          message: this.$t("ELIXIO_CONNECT.SOMETHING_WENT_WRONG"),
        });
      } finally {
        this.loading = false;
      }
    },

    async handleAuthorize() {
      return await swal.fire({
        text: this.$t("ELIXIO_CONNECT.ELIXIO_CONNECT_CONFIRM_THIS_SUBSCRIPTION"),
        customClass: {
          popup: "warning-confirm",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
        showLoaderOnConfirm: this.loading,
        allowOutsideClick: () => !swal.isLoading(),

        preConfirm: async () => {
          return await this.subscribe();
        },
      });
    },
  },

  mounted() {},

  watch: {
    service(newValue) {
      this.serviceData = cloneDeep(newValue);
    },
  },
};
</script>
